const TcsFresh = () => {
  return (
    <div>
  
      <div className="flex flex-col justify-center items-center mb-[1.5rem] ">
        <hr className="w-[50rem]"/>
        <div className="lg:flex md:grid flex-1 justify-center items-start mx-auto max-w-[60rem] my-[5rem] gap-5  ">
        
          <div className="flex flex-col justify-center">
            <h1 className="font-bold text-3xl text-[#373737]">
              TCS Fresh
            </h1>
            <p className="text-sm text-md  lg:max-w-[25rem] md:w-[30rem] mt-[1rem]">
              Comming Soon
            </p>
            <p>For further details, please contact us at 111-123-456.</p>
              
          </div>
          <div className="flex-1 flex flex-col justify-center">
              <img src="/overland/image-6.jpg" alt="" className="max-w-[45rem] h-[30vh]"/>
          </div>
          </div>
      
      </div>
    </div>
  );
};
  
export default TcsFresh;
  